<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="80%"
    :close-on-click-modal="false"
    :draggable="true"
  >
    <el-row :gutter="12" class="demo-radius" align="middle" justify="start">
      <el-col :span="6">
        <el-select
          v-model="editingColumn.columnType"
          class="m-2"
          placeholder="列类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in columType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.isExpand" :disabled="!(editingColumn.columnType==='normal' || editingColumn.columnType==='link')" label="显示在扩展区" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.isLocalvalue" :disabled="!(editingColumn.columnType==='normal')" label="锁定值" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.isRequired" :disabled="!(editingColumn.columnType==='normal')" label="必填" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.actions.edit" :disabled="!(editingColumn.columnType==='action')" label="编辑按钮" size="large" />
      </el-col>
      <el-col :span="6">
        <el-input v-model="editingColumn.actions.editBtnName" :disabled="!(editingColumn.columnType==='action')" :placeholder="'编辑按钮名称'" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.actions.delete" :disabled="!(editingColumn.columnType==='action')" label="删除按钮" size="large" />
      </el-col>
      <el-col :span="6">
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.isShowInAddDlg" :disabled="!(editingColumn.columnType==='normal')" label="是添加字段" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.isShowInEditDlg" :disabled="!(editingColumn.columnType==='normal')" label="显示在编辑窗口" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.disabledInEditDlg" :disabled="!(editingColumn.columnType==='normal')" label="在编辑窗口只读" size="large" />
      </el-col>
      <el-col :span="6">
        <el-input v-model="editingColumn.placeholder" :disabled="!(editingColumn.columnType==='normal')" :placeholder="'编辑框的placeholder'" />
      </el-col>
      <el-col :span="6">
        <el-select
          v-model="editingColumn.tagInEditDlg"
          class="m-2"
          placeholder="标签样式"
          style="width: 100%"
          :disabled="!(editingColumn.columnType==='normal')"
        >
          <el-option
            v-for="item in tagDefinedList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input v-model="editingColumn.srcDataUrl" :disabled="!(editingColumn.tagInEditDlg==='DropDownSelector' || editingColumn.tagInEditDlg==='UploadSingleFileKit' || editingColumn.tagInEditDlg==='CascaderSelector')" :placeholder="'绑定数据源'" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.allowCreate" :disabled="!(editingColumn.tagInEditDlg==='DropDownSelector')" label="下拉选择器是否允许创建" size="large" />
      </el-col>
      <el-col :span="6">
        <el-checkbox v-model="editingColumn.multiple" :disabled="!(editingColumn.tagInEditDlg==='DropDownSelector')" label="下拉选择器是否允许多选" size="large" />
      </el-col>
      <el-col :span="6">
        <el-select
          v-model="editingColumn.pickerType"
          class="m-2"
          placeholder="日期选择类型"
          style="width: 100%"
          :disabled="!(editingColumn.tagInEditDlg==='DatePicker')"
        >
          <el-option
            v-for="item in dateSelectTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select
          v-model="editingColumn.valueFormat"
          class="m-2"
          placeholder="日期格式"
          style="width: 100%"
          :disabled="!(editingColumn.tagInEditDlg==='DatePicker')"
        >
          <el-option
            v-for="item in dateFormatList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
    </el-row>
    <template #footer>
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onOk">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits } from 'vue'
import { deepCopy } from '../utils'

const props = defineProps({
  column: {
    type: Object,
    required: true
  },
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update:modelValue'])

const visible = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emits('update:modelValue', val)
})

// 编辑中的列数据副本，点击“确定”后才写回
const editingColumn = ref(deepCopy(props.column))

// 确定：将编辑结果写回原列
const onOk = () => {
  // eslint-disable-next-line vue/no-mutating-props
  Object.assign(props.column, editingColumn.value)
  emits('update:modelValue', false)
}

// 取消：不保存，直接关闭
const onCancel = () => {
  emits('update:modelValue', false)
}

// 弹窗标题
const title = computed(() => `编辑[${(props.column as { label?: string }).label || ''}]列属性`)

// 列类型
const columType = [
  {
    value: 'normal',
    label: '普通列'
  },
  {
    value: 'expand',
    label: '展开列'
  },
  {
    value: 'action',
    label: '功能列'
  },
  {
    value: 'link',
    label: '链接'
  }
]

// 查询区/添加/编辑的组件类型
const tagDefinedList = [
  {
    value: 'el-input',
    label: '文本框'
  },
  {
    value: 'DropDownSelector',
    label: '下来选择器'
  },
  {
    value: 'CascaderSelector',
    label: '多级选择器'
  },
  {
    value: 'SwitchItem',
    label: 'switch开关'
  },
  {
    value: 'ImageItem',
    label: '图片'
  },
  {
    value: 'DatePicker',
    label: '日期选择器'
  },
  {
    value: 'UploadSingleFileKit',
    label: '上传文件'
  }
]

// 日期选择类型
const dateSelectTypeList = [
  {
    value: 'date',
    label: '日期'
  },
  {
    value: 'month',
    label: '月份'
  },
  {
    value: 'year',
    label: '年份'
  },
  {
    value: 'daterange',
    label: '日期范围'
  },
  {
    value: 'monthrange',
    label: '月份范围'
  }
]

// 日期格式
const dateFormatList = [
  {
    value: 'YYYY-MM-DD',
    label: 'YYYY-MM-DD'
  },
  {
    value: 'YYYYMMDD',
    label: 'YYYYMMDD'
  },
  {
    value: 'YYYY-MM',
    label: 'YYYY-MM'
  },
  {
    value: 'YYYYMM',
    label: 'YYYYMM'
  },
  {
    value: 'YYYY',
    label: 'YYYY'
  }
]
</script>
